module.exports = __webpack_public_path__ + "a768e7de/img/question-icon.06c20c5d.svg";